import {
  Button,
  Card,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { formatDateInBrowserTZ } from 'components/UserDashboard/utils';
import { useNavigate } from 'react-router-dom';
import { ProviderTask } from '../../models/providerTask';
import { useCompleteTask } from '../../api/providerHome/mutations/useCompleteTask';

type Props = {
  task: ProviderTask;
};

export const TaskCard = ({ task }: Props) => {
  const navigate = useNavigate();
  const { mutate: completeTask, isLoading: isCompleting } = useCompleteTask();

  const userId = task.user?.id;
  const patientName = [task.user?.first_name, task.user?.last_name]
    .filter(Boolean)
    .join(' ');

  const openPatient = () => {
    if (userId) navigate(`/user-details/${userId}`);
  };

  const handleCardClick = () => {
    if (task.healthie_url) {
      window.open(task.healthie_url, '_blank', 'noopener,noreferrer');
    } else {
      openPatient();
    }
  };

  return (
    <Card
      flexDirection="row"
      alignItems="flex-start"
      gap={3}
      p={3}
      bg="white"
      shadow="none"
      borderWidth="1px"
      borderColor="muted.200"
      borderLeftWidth="3px"
      borderLeftColor="aqua"
      borderRadius="md"
      cursor="pointer"
      onClick={handleCardClick}
      transition="filter 0.12s ease"
      _hover={{ filter: 'brightness(0.97)' }}
    >
      <VStack gap={0} flex={1} minW={0} align="stretch">
        <Text fontWeight={600} color="muted.600">
          {task.task}
        </Text>

        {patientName && (
          <Text
            color="secondary.200"
            fontWeight={500}
            w="fit-content"
            _hover={{ textDecoration: 'underline' }}
            onClick={(e) => {
              e.stopPropagation();
              openPatient();
            }}
          >
            {patientName}
          </Text>
        )}
        {task.created_at && (
          <Text color={'subtle'}>
            Assigned {formatDateInBrowserTZ(task.created_at, 'MMM D, YYYY')}
          </Text>
        )}
      </VStack>

      {task.dismissable && (
        <Button
          aria-label="Mark task completed"
          flexShrink={0}
          loading={isCompleting}
          mt="2px"
          size="sm"
          variant="outline"
          onClick={(e) => {
            e.stopPropagation();
            completeTask(task.id);
          }}
        >
          Mark completed
        </Button>
      )}
    </Card>
  );
};
